import React from 'react';
import { motion } from 'framer-motion';
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from '../ui/accordion';
import { faq } from '../../data/faq';

const fadeUp = {
  initial: { opacity: 0, y: 24 },
  whileInView: { opacity: 1, y: 0 },
  viewport: { once: true, margin: '-80px' },
  transition: { duration: 0.6, ease: [0.22, 1, 0.36, 1] },
};

export default function FAQV2() {
  return (
    <section id="faq" className="bg-background py-24 lg:py-32">
      <div className="max-w-5xl mx-auto px-6 lg:px-12">
        <motion.div {...fadeUp} className="mb-16 lg:mb-20">
          <span className="text-[11px] font-semibold uppercase tracking-[0.3em] text-foreground/55">
            05 — Questions fréquentes
          </span>
          <h2 className="mt-4 font-display text-5xl sm:text-6xl lg:text-7xl leading-[0.9] tracking-tight text-foreground max-w-3xl">
            Vos questions, <span className="italic">nos réponses</span>.
          </h2>
        </motion.div>

        <Accordion type="single" collapsible className="border-y border-foreground/15">
          {faq.map((item, idx) => (
            <AccordionItem
              key={item.id}
              value={item.id}
              className="border-b border-foreground/15 last:border-b-0 group"
            >
              <AccordionTrigger
                className="py-7 lg:py-9 font-display text-2xl sm:text-3xl lg:text-4xl tracking-tight text-foreground hover:no-underline hover:text-amber-700 focus:outline-none focus-visible:ring-2 focus-visible:ring-foreground focus-visible:ring-offset-2 rounded text-left items-baseline gap-6 [&>svg]:hidden"
              >
                <span className="font-sans text-xs lg:text-sm font-semibold uppercase tracking-[0.3em] text-foreground/40 shrink-0 mt-1">
                  {String(idx + 1).padStart(2, '0')}
                </span>
                <span className="flex-1">{item.question}</span>
                <span
                  aria-hidden="true"
                  className="shrink-0 font-display text-3xl text-foreground/50 transition-transform duration-300 group-data-[state=open]:rotate-45 group-data-[state=open]:text-amber-600"
                >
                  +
                </span>
              </AccordionTrigger>
              <AccordionContent className="pb-7 lg:pb-9 pl-0 sm:pl-16">
                <p className="max-w-2xl text-base lg:text-lg text-foreground/65 leading-relaxed">
                  {item.answer}
                </p>
              </AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </div>
    </section>
  );
}
